import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ApirestService } from './apirest.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private service: ApirestService,
    private router: Router,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    if (token) {
      if (this.service.isTokenExpired(token)) {
        //localStorage.clear();
        //this.router.navigate(['/login']);
        localStorage.setItem('token', '');
        localStorage.setItem('user', '');
        localStorage.setItem('username', '');
        localStorage.setItem('rol_user', '');
        localStorage.setItem('param', '');
        localStorage.setItem('logged', '');
        this.router.navigate(['/home']);
        return throwError(() => new Error('Token expirado'));
      }

      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });

      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            //localStorage.clear();
            localStorage.setItem('token', '');
            localStorage.setItem('user', '');
            localStorage.setItem('username', '');
            localStorage.setItem('rol_user', '');
            localStorage.setItem('param', '');
            localStorage.setItem('logged', '');
            this.router.navigate(['/home']);
          }
          return throwError(() => error);
        }),
      );
    }

    return next.handle(req);
  }
}
